import { gql, useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { ErrorMessage } from '~/components/error-message';
import { Flex_GoogleLoginUrlQuery, Flex_GoogleLoginUrlQueryVariables } from '~/typings/graphql';
import { GoogleSignUpButton } from './google-signup.style';

export const GOOGLE_LOGIN_URL_QUERY = gql`
  query Flex_GoogleLoginUrl($path: String, $language: String) {
    googleLoginUrl(app: funnel, path: $path, language: $language)
  }
`;

type Props = {
  error?: string;
  /**
   * @deprecated location is mostly window.location in the browser.
   * passing it as props is dangerous and might mutate the object.
   * If you want to pass location, pass the pathname as a string.
   * for the existing location.assign() used in the component, we will be using
   * window.location going forward
   */
  location?: Location;
  redirectPath?: string;
  language?: string;
};

export const GoogleSignup = ({
  error,
  redirectPath,
  location = window.location,
  language = window.Localize?.getLanguage(),
}: Props) => {
  const path = redirectPath || location.pathname;
  const [getLoginUrl, { data, error: queryError, loading }] = useLazyQuery<
    Flex_GoogleLoginUrlQuery,
    Flex_GoogleLoginUrlQueryVariables
  >(GOOGLE_LOGIN_URL_QUERY, {
    fetchPolicy: 'no-cache',
  });

  const handleClick = () => {
    const variables = { path, language };
    getLoginUrl({ variables });
  };

  useEffect(() => {
    if (data?.googleLoginUrl) {
      if (location?.assign) {
        location?.assign(data.googleLoginUrl);
      } else {
        window.location.assign(data.googleLoginUrl);
      }
    }
  }, [data]);

  return (
    <>
      <ErrorMessage error={error || queryError} mb={2} />
      <GoogleSignUpButton disabled={loading} fullWidth onClick={handleClick}>
        Sign up with Google
      </GoogleSignUpButton>
    </>
  );
};
